import React, { FC, useState, useEffect, useContext, useRef } from 'react'

import _ from 'lodash'
import { isMobile, isTablet } from 'react-device-detect'
import history from '../../../../history'

import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericColumn from '../../../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericButton from '../../../../GenericComponents/GenericButton'

import { SectionContainer, StarImage, VideoSectionVideo, VideoPlayButton } from '../../style/LandingStyle'


import miazgaProgramIcon from "../../../../assets/REDESIGN_Assets/Landing/miazga-program-icon.svg"
import treningiSpecjalistyczneIcon from '../../../../assets/REDESIGN_Assets/Landing/treningi-specjalistyczne-icon.svg'
import dodatkiEkstraIcon from '../../../../assets/REDESIGN_Assets/Landing/dodatki-ekstra-icon.svg'
import poradyEkspertowIcon from '../../../../assets/REDESIGN_Assets/Landing/porady-ekspertow-icon.svg'
import panelDietyIcon from '../../../../assets/REDESIGN_Assets/Landing/panel-diety-icon.svg'
import treningiWspolneIcon from '../../../../assets/REDESIGN_Assets/Landing/treningi-wspolne-icon.svg'
import picieWodyIcon from '../../../../assets/REDESIGN_Assets/Landing/picie-wody-icon.svg'
import kalkulatorKaloriiIcon from '../../../../assets/REDESIGN_Assets/Landing/kalkulator-kalorii-icon.svg'

interface JoinMiazgaSectionInterface {

}

const JoinMiazgaSection: FC<JoinMiazgaSectionInterface> = ({ }) => {

  const pushToLogin = () => {
    history.push("/zaloguj")
  }

  const [isVideoPlaying, setVideoPlaying] = useState<boolean>(false)
  const videoRef: any = useRef(null)

  const playVideo = () => {
    videoRef && videoRef.current && videoRef.current.play()
    setVideoPlaying(true)
  }

  const pauseVideo = () => {
    videoRef && videoRef.current && videoRef.current.pause()
    setVideoPlaying(false)
  }

  return (
    <SectionContainer className="join-miazga-section">

      <GenericRow margin="7% 0 0 0">
        <GenericTextSpan fSize="1.1rem" color="#e39400" fWeight="bold">
          MIAZGA
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan margin="3% 0 0 0" fSize="2.8rem" fWeight="bold">
          MIAZGA od środka
        </GenericTextSpan>
      </GenericRow>
      <GenericRow margin="0% 0 0 0" justify="center" wrap={"wrap"} align="baseline">

        <GenericColumn margin="7% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col" >
          <GenericRow>
            <StarImage src={miazgaProgramIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Program MIAZGA

          </GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Aktualnie dostępnych 14 poziomów,
            320 treningów i liczba ta stale rośnie. </GenericTextSpan>
        </GenericColumn>

        <GenericColumn margin="7% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">
          <GenericRow>
            <StarImage src={treningiSpecjalistyczneIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Treningi specjalistyczne

          </GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Dla osób skrajnie otyłych oraz osób starszych.


          </GenericTextSpan>
        </GenericColumn>



        <GenericColumn margin="7% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">
          <GenericRow>
            <StarImage src={dodatkiEkstraIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.8rem"> Dodatki ekstra</GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">
            Dostęp do ponad 400 treningów
            takich jak: taniec, pilates, joga,
            samoobrona oraz aeroboks.
          </GenericTextSpan>
        </GenericColumn>


        <GenericColumn width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">

          <GenericRow>
            <StarImage src={poradyEkspertowIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Porady ekspertów </GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Dodatkowe działy, takie jak fizjo, kosmetolog, seksuolog, stylistka.

          </GenericTextSpan>
        </GenericColumn>

        <GenericColumn margin="7% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">
          <GenericRow>
            <StarImage src={panelDietyIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Panel diety</GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Panel z 14 rodzajami diet m.in.
            IO, Hashi, cukrzyca oraz dział kuchnia pełen prostych i zdrowych posiłków.

          </GenericTextSpan>
        </GenericColumn>

        <GenericColumn margin="3% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">
          <GenericRow>
            <StarImage src={treningiWspolneIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Treningi wspólne </GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Zrób trening z kumpelą niezależnie od tego gdzie mieszkacie.

          </GenericTextSpan>
        </GenericColumn>

        <GenericColumn margin="3% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">
          <GenericRow>
            <StarImage src={picieWodyIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Picie wody</GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Przypomnienia o piciu wody, bo
            odpowiednie nawodnienie to
            pierwszy krok na drodze do
            zdrowia.  </GenericTextSpan>
        </GenericColumn>

        <GenericColumn margin="3% 0" width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"} className="element-col">
          <GenericRow>
            <StarImage src={kalkulatorKaloriiIcon} />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Kalkulator kalorii</GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Wyliczymy Twoje faktyczne zapotrzebowanie kaloryczne.

          </GenericTextSpan>
        </GenericColumn>



        {/* <GenericColumn width={isMobile && !isTablet ? "100%" : isTablet ? "50%" : "25%"}>

          <GenericRow>
            <StarImage />
          </GenericRow>
          <GenericTextSpan margin="7% 0" fWeight="bold" fSize="1.6rem">Wiele platform </GenericTextSpan>
          <GenericTextSpan lineHeight="1.9rem" display="block" width="80%">Masz dostęp do aplikacji
            internetowej oraz mobilnych na
            Android oraz iOS.</GenericTextSpan>
        </GenericColumn> */}

      </GenericRow>

      <GenericRow wrap="wrap">

        {/* {!isMobile && <GenericColumn margin={""} width={isMobile ? "100%" : "50%"} className="miazga-app-video">
          <GenericTextSpan margin="2% 0 0 0" fWeight="bold" fSize="2.8rem" tAlign="left" >
            Sprawdź MIAZGĘ już teraz!
          </GenericTextSpan>
          <GenericTextSpan margin="2% 0 0 0" fWeight="normal" fSize="1.3rem" tAlign="left" >
            Ja już na Ciebie tam czekam!
          </GenericTextSpan>
          <GenericButton zIndex={isMobile ? "2" : "unset"} onClick={pushToLogin} margin={"3rem 1.25rem 1.25rem 1.25rem"} className="standard" padding="15px 50px" borderRadius={"30px"} width="max-content"><span className="button-span">Zarejestruj się</span></GenericButton>
        </GenericColumn>} */}

        <GenericColumn width={isMobile ? "100%" : "50%"} className="miazga-app-video">
          {/* <video
            // playsinline={true}
            playsInline
            webkit-playsinline={true}
            webkit-playsInline
            onClick={isVideoPlaying && pauseVideo} ref={videoRef}
            loop muted src={appVideo && appVideo.data.files[2].link}></video> */}

          <VideoSectionVideo playsinline={true}
            playsInline
            className={`${isTablet ? "isTablet" : ""} app-video`}
            webkit-playsinline={true}
            poster={"https://i.vimeocdn.com/video/1361660176-8632754b47ee7d8f7a742dbf77deb12ca452b395e593b53bc136d07767c3abac-d_1920x1080?r=pad"}
            webkit-playsInline onClick={isVideoPlaying && pauseVideo} ref={videoRef} src={"https://player.vimeo.com/progressive_redirect/playback/669794776/rendition/1080p/1080p.mp4?loc=external&oauth2_token_id=1354788489&signature=42678ab328161626f36e666978d7156e3005858b92b46e553ea09c915cd65fbf"} preload={"auto"} autoBuffer={true} type="video/mp4"  >


          </VideoSectionVideo>
          {!isVideoPlaying && <VideoPlayButton className="join-miazga-section" onClick={playVideo} />}
        </GenericColumn>

      </GenericRow>

    </SectionContainer >
  )
}

export default JoinMiazgaSection
